export const FREQUENCY = ['daily', 'weekly', 'monthly'];
export const VIEWS = ['Historical Prices', 'Dividends / Splits'];
export const TIMEPERIODS = ['1D', '1W', '1M', '3M', '6M', '1Y', '5Y', '10Y', 'MAX'];
